// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1qmyJ","description":"PatientConsentPreview_description__LbeZj"};